<template>
  <div class="page-content">
    <page-template
      ref="brandTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <el-dialog :title="dialogTitle" width="700px" custom-class="category-dialog" :close-on-click-modal="false"
               :visible.sync="addDialogShow" @close="closeDialog">
      <el-form ref="form" :rules="rules" :model="form" :show-message="false" style="padding-left: 100px">
        <el-col :span="12" v-if="operationType == 'edit'">
          <el-form-item label='品牌编码' prop="code">
            <el-input v-model="form.code" placeholder='请输入品牌编码' disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label='品牌名称' prop="name">
            <el-input v-model="form.name" placeholder='请输入品牌名称' :maxlength="16"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='备注' prop="remarks" label-width="9%">
            <el-input type="textarea" :maxlength="16" :rows="2" v-model="form.remarks" style="width:400px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="foot" style="text-align: center;padding:20px 0;">
            <el-button type='primary' @click="save">保存</el-button>
            <el-button type='default' @click="reset">取消</el-button>
          </div>
        </el-col>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {
      pageTemplate,
    },
    data() {
      return {
        loading: false,
        dialogTitle: '',
        form: {
          code: '',
          name: '',
          remarks: ''
        },
        rules: {
          name: [{required: true, message: "请输入品牌名称", trigger: "blur"}]
        },
        addDialogShow: false,
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '品牌名称/编码',
              prop: 'otherName',
              type: 'input',
              isFuzzy: true,
              placeholder: '请输入品牌名称/编码',
              labelWidth: '110'
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.add
          },
          {
            label: '同步至门店',
            code: 'sync',
            callback: this.sync,
            filter: () => {
              return false
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.edit
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
          },
        ],
        // 表格信息配置
        tableOptions: {
          // showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {label: '品牌编码', prop: 'code', width: '50', align: 'center'},
            {label: '品牌名称', prop: 'name', align: 'center'},
            // {
            //   label: '状态',
            //   prop: 'status',
            //   width: '120',
            //   align: 'center',
            //   enumData: this.$utils.getCacheStatus('asBrand.status')
            // },
            // {label: '创建人', prop: 'createBy', width: '120', align: 'center'},
            {label: '创建时间', prop: 'createDttm', align: 'center'},
          ],
          url: api.archives.brand
        },
        // 添加字段
        // addColumns: {
        //   labelWidth: '120px',
        //   span: 12,
        //   columns: [
        //     {
        //       label: '品牌编码',
        //       type: 'input',
        //       prop: 'code',
        //       disabled:true,
        //     },
        //     {
        //       label: '品牌名称',
        //       type: 'input',
        //       prop: 'name',
        //       rule: [
        //         {required: true, message: '请输入品牌名称', trigger: 'blur'},
        //       ],
        //       placeholder: "请输入品牌名称",
        //       change:this.checkName
        //     },
        //     {
        //       label: '备注',
        //       type: 'textarea',
        //       prop: 'remarks',
        //       span: 22,
        //     },
        //
        //   ], // 表单label
        //   url: api.archives.brand
        // },
        isReaptName: false,
        operationType: '',
      };
    },
    created() {
      // this.setStore(this.searchOptions.simple);
    },
    methods: {
      edit(row) {
        console.log(row)
        this.dialogTitle = '编辑品牌名称'
        this.operationType = 'edit'
        this.addDialogShow = true
        this.$axios.fetchGet(api.archives.brand + '?id=' + row.id, {}).then(res => {
          this.form = res.data
          this.isReaptName = true
        }).catch(() => {
        })
      },
      add() {
        this.dialogTitle = '新增品牌名称'
        this.operationType = 'add'
        this.addDialogShow = true
      },
      closeDialog() {
        this.addDialogShow = false
        this.form = {
          code: '',
          name: '',
          remarks: ''
        }
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      },
      // 取消
      reset() {
        this.closeDialog()
      },
      save() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.checkName(this.form.name).then(data => {
              if (data) {
                this.$loading({text: '提交中，请稍后。。。'})
                this.$axios[this.operationType == 'add' ? 'fetchPost' : 'fetchPut']
                (api.archives.brand, this.form).then(data => {
                  if (data.code == 200) {
                    this.$notify({
                      type: "success",
                      title: (this.operationType == 'add' ? '添加' : '编辑') + '操作',
                      message: '成功',
                      showClose: false,
                    });
                    // this.$message({type: 'success', message: (this.operationType == 'add' ? '添加' : '编辑') + '成功!'});
                    this.closeDialog()
                    this.$refs.brandTemplate.getData()
                  } else {
                    if (data.code === 11010142) {
                      this.$message({message: data.msg, type: 'warning'});
                    } else {
                      this.$message({message: data.msg, type: 'error'});
                    }
                  }
                }).catch((err) => {
                }).finally(() => {
                  this.$loading({}).close()
                })
              }
            })
          } else {
            return false
          }
        })
      },
      // 校验名称重复
      checkName(val) {
        return new Promise(resolve => {
          this.$axios.fetchGet(api.archives.brandName + '?brandName=' + val, {}).then(res => {
            this.loading = false;
            if (res.code == 200) {
              if (!res.data) {
                this.$message({type: 'warning', message: '名称重复'});
                this.form.name = ''
                this.isReaptName = false
              } else {
                this.isReaptName = true
              }
              resolve(this.isReaptName)
            } else {
              this.$message({type: 'error', message: res.msg});
            }
          })
            .catch(err => {
              this.$message({type: 'error', message: '获取失败!'});
            })
        })
      },
      sync() {
        // 门店集合
        let ids = this.$refs.brandTemplate.getSimpleParams().storeId;
        if (!ids) {
          this.$message({message: '请选择门店后进行同步', type: 'warning'});
          return;
        }
        // 需要同步的数据
        let tableRows = this.$refs.brandTemplate.getTableSelectRow();
        if (tableRows.length === 0) {
          this.$message({message: '请勾选一条数据后进行同步', type: 'warning'});
          return;
        }
        if (this.isReaptName) {
          this.$axios
            .fetchPost(api.archives.brand + '/sync', {brandList: tableRows, ids: ids})
            .then(data => {
              if (data.code === 200 && data.data) {
                this.$notify({
                  type: "success",
                  title: '同步操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '同步成功', type: 'success'});
              } else {
                this.$message({message: data.msg, type: 'error'});
              }
            }).catch(err => {
            this.$message({message: '请求失败！', type: 'error'});
          });
        }
      },
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Brand.vue